const notesLandingPage = {
  title: 'Notes',
  infoTitle: 'Note',
  description: 'Choose to create a new note or view older notes',
  showOlder: 'Show older notes'
}

export default notesLandingPage
